import { createStore, combineReducers } from 'redux'
import userDataReducer from './reducers/userDataReducer';
import stepOneReduser from './reducers/stepOneReduser';
import stepTwoReducer from './reducers/stepTwoReducer';
import validationReducer from './reducers/validationReducer';
import loadingReducer from './reducers/loadingReducer';
import rangeSliderReduser from './reducers/rangeSliderReduser';

const reducers = combineReducers(Object.assign({}, {userDataReducer,stepOneReduser,stepTwoReducer,validationReducer,loadingReducer,rangeSliderReduser}))
const store = createStore(reducers);
export default store


// WEBPACK FOOTER //
// src/store.js